import React from 'react';

const myComp = ({prop1,prop2}) => (<div>
   myComp  {prop1} !
</div>);

export default myComp;


// WEBPACK FOOTER //
// ./src/TestComp.js